module.exports = __webpack_public_path__ + "media/images/pepsi_digin_day/2024_scavenger_hunt_map-9188b9db35fca12e58a32a1685de1979.png";